const normalizeCmsLinks = ({ year, carline, bodyStyle }) => {
  try {
    const links = new window.GmdsCmsLinks();
    const lnv = links.getCmsPageURL('lnv', '', carline, bodyStyle, `${year}`);
    return lnv ? { lnv } : {};
  } catch (e) {
    return {};
  }
};

export default normalizeCmsLinks;
